import { isValid, parse } from 'date-fns';
import validate from 'validate.js';
import XRegExp from 'xregexp';
const dateRegExp = /^\d{2}\/\d{2}\/\d{4}$/;
const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
const INVALID_MSG = '^is invalid';
function isValidDate(str, format) {
    const date = parse(str, format, new Date());
    return isValid(date);
}
validate.extend(validate.validators.datetime, {
    parse: (value, options) => {
        if (!value) {
            return false;
        }
        if (!dateRegExp.test(value)) {
            return true;
        }
        return !isValidDate(value, options.format || DEFAULT_DATE_FORMAT);
    },
    format: (value) => {
        return value;
    }
});
validate.validators.customFormat = (value, options) => {
    if (!value) {
        return;
    }
    try {
        const { pattern } = options;
        const ignoreCase = pattern.includes('(?i)');
        const patternStr = pattern
            .replace(/\\A/i, '^')
            .replace(/\\Z/i, '$')
            .replace(/\(\?i\)/g, '');
        const regExp = XRegExp(patternStr, ignoreCase ? 'i' : undefined);
        const message = options.message || INVALID_MSG;
        if (regExp.test(value)) {
            return;
        }
        return message;
    }
    catch {
        // does nothing
    }
};
let phoneNumberModule = null;
async function loadPhoneNumberModule() {
    if (!phoneNumberModule) {
        phoneNumberModule = await import('awesome-phonenumber');
    }
    return phoneNumberModule;
}
validate.validators.phone = (value, { message, country: countryOrCountries = [], mobile = true, strict = true, shouldApplyValidation = () => true }, _key, attributes) => {
    if (!value || !shouldApplyValidation(value, attributes)) {
        return;
    }
    const countries = Array.isArray(countryOrCountries)
        ? countryOrCountries
        : new Array(countryOrCountries);
    if (!phoneNumberModule) {
        loadPhoneNumberModule().then(() => {
            // does nothing
        });
        return message || INVALID_MSG;
    }
    const { parsePhoneNumber } = phoneNumberModule;
    try {
        const num = parsePhoneNumber(value, { regionCode: countries[0] });
        if (!strict) {
            if (num.possible)
                return;
            return message || INVALID_MSG;
        }
        const isValidPhone = countries.length === 0
            ? num.valid
            : countries.some(country => parsePhoneNumber(value, { regionCode: country }).valid);
        if (isValidPhone) {
            if (mobile && !num.typeIsMobile) {
                return message || '^is not a mobile phone';
            }
            return;
        }
    }
    catch {
        return message || INVALID_MSG;
    }
    return message || INVALID_MSG;
};
export default validate;
//# sourceMappingURL=validate.js.map